import {
  fetchQuizById,
  fetchQuizAttemptsByQuizId,
  postQuizAttemptByQuizId,
  putQuizAttemptByQuizId,
  patchQuizAttemptByQuizId,
} from '@/models/quizzes'
import { ActionTree, ActionContext } from 'vuex'
import { QuizzesState } from './state'
import { QuizAttempt } from '../../types'

const actions: ActionTree<QuizzesState, {}> = {
  getQuizById: async (
    context: ActionContext<QuizzesState, {}>,
    quizId: string
  ) => {
    try {
      const response = await fetchQuizById(quizId)
      context.commit('CURRENT_QUIZ_UPDATED', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      context.commit('CURRENT_QUIZ_UPDATED', '')
    }
  },

  getQuizAttemptsByQuizId: async (
    context: ActionContext<QuizzesState, {}>,
    quizId: string
  ) => {
    try {
      const response = await fetchQuizAttemptsByQuizId(quizId)
      context.commit('PREVIOUS_QUIZ_ATTEMPTS_UPDATED', response.results)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  startQuizAttemptByQuizId: async (
    context: ActionContext<QuizzesState, {}>,
    quizId: string
  ) => {
    try {
      const response = await postQuizAttemptByQuizId(quizId)
      context.commit('UPDATE_CURRENT_QUIZ_ATTEMPT', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  finishQuizAttempt: async (
    context: ActionContext<QuizzesState, {}>,
    data: { quizId: string; attemptId: string; submission: QuizAttempt }
  ) => {
    try {
      const response = await putQuizAttemptByQuizId(data)
      context.commit('FINISHED_QUIZ_ATTEMPT', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  updateQuizAttempt: async (
    context: ActionContext<QuizzesState, {}>,
    data: {
      quizId: string
      attemptId: string
      submission: QuizAttempt
      status: string
    }
  ) => {
    try {
      const response = await patchQuizAttemptByQuizId(data)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  resumeQuizAttempt: (
    context: ActionContext<QuizzesState, {}>,
    attempt: QuizAttempt
  ) => {
    context.commit('UPDATE_CURRENT_QUIZ_ATTEMPT', attempt)
  },

  clearQuizStore: (context: ActionContext<QuizzesState, {}>) => {
    context.commit('CURRENT_QUIZ_UPDATED', {})
    context.commit('PREVIOUS_QUIZ_ATTEMPTS_UPDATED', [])
    context.commit('UPDATE_CURRENT_QUIZ_ATTEMPT', {})
    context.commit('FINISHED_QUIZ_ATTEMPT', {})
  },

  restartQuiz: (context: ActionContext<QuizzesState, {}>) => {
    context.commit('FINISHED_QUIZ_ATTEMPT', {})
  },
}

export default actions
